import { useXScale, useDrawingArea } from '@mui/x-charts-pro';
import { Tooltip } from '@mui/material';
import { ArrowRight, Schedule } from '@mui/icons-material';
import { flagEmojiString } from '@/components/common/FlagsWithGeoAddr';
import { formatMsUTCToHM } from '@/utilities/timeUtils';
import { TachographBorderCrossings } from './TachographService';

export function BorderCrossingsLayer({ borderCrossings }: { borderCrossings: TachographBorderCrossings[] }) {
  const { top, height } = useDrawingArea();
  const xScale = useXScale();

  return (
    <g pointerEvents="none">
      {borderCrossings.map((bc, i) => {
        const xHours = bc.timeInDayMillis / 3_600_000;
        const px = xScale?.(xHours);
        if (px == null) return null;

        const fromFlag = flagEmojiString(bc.fromCountry.code);
        const toFlag = flagEmojiString(bc.toCountry.code);

        const FONT_SIZE = 12;
        const pillWidth = 54;
        const pillHeight = 18;

        const tooltipTitle = (
          <div style={{ display: 'flex', alignItems: 'center', fontSize: '10px !important' }}>
            <strong>
              <Schedule sx={{ fontSize: '12px', marginBottom: '-2px', marginRight: '5px' }} />[
              {formatMsUTCToHM(bc.timeInDayMillis)}]
            </strong>
            <span style={{ marginLeft: '5px' }}>
              {fromFlag} {bc.fromCountry.name}
            </span>
            <ArrowRight sx={{ fontSize: '12px !important' }} />
            <span>
              {toFlag} {bc.toCountry.name}
            </span>
          </div>
        );

        return (
          <g key={i}>
            {/* Függőleges jelölővonal */}
            <line
              x1={px}
              x2={px}
              y1={top - 8}
              y2={top + height + 8}
              stroke="var(--mui-palette-text-secondary)"
              strokeWidth={2}
            />
            {/* Badge (fehér „pill” kerettel) */}
            <foreignObject x={px - pillWidth / 2} y={top - 25} width={pillWidth} height={pillHeight + 8}>
              <Tooltip
                title={tooltipTitle}
                slotProps={{ tooltip: { sx: { margin: '5px 0px !important', padding: '4px' } } }}
                placement="top"
                arrow
              >
                <div
                  style={{
                    width: pillWidth,
                    height: pillHeight,
                    borderRadius: '8px',
                    border: '2px solid  var(--mui-palette-text-secondary)',
                    background: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: FONT_SIZE,
                    color: '#555',
                    pointerEvents: 'auto',
                  }}
                >
                  {fromFlag}
                  <ArrowRight color="action" sx={{ fontSize: '16px', marginBottom: '-2px' }} />
                  {toFlag}
                </div>
              </Tooltip>
            </foreignObject>
          </g>
        );
      })}
    </g>
  );
}
